import { depositTypeLabel } from '../../../../helpers/depositTypes';

/**
 * Chips de filtros activos que viven bajo el título del Card principal.
 * Pasa el estado de filtros + opciones de depósito y construye una
 * lista de etiquetas-resumen ("Género: MUJER", "Búsqueda: foo"…) que
 * el usuario ve sin tener que volver a abrir los desplegables.
 *
 * Si no hay filtros activos devuelve null (el bloque desaparece).
 */
const chipStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  padding: '3px 10px',
  fontSize: 11,
  backgroundColor: '#F1F3F5',
  border: '1px solid #E1E3E5',
  borderRadius: 12,
  color: '#1F3A5F',
  fontWeight: 500,
};

export const ActiveFilterChips = ({
  filters,
  depositsValue,
  depositRolesValue,
  depositGroupsValue,
  depositOptions,
  groupOptions = [],
  familyQuery,
}) => {
  const chips = [];

  if (filters.genders?.value) chips.push(`Género: ${filters.genders.value.split(':').join(', ')}`);
  if (filters.categories?.value) chips.push(`Categorías: ${filters.categories.value.split(':').join(', ')}`);
  if (filters.subcategories?.value) chips.push(`Subcategorías: ${filters.subcategories.value.split(':').join(', ')}`);
  // Temporadas y años solo existen como filtro en existencias (eficacia
  // los lleva como selector de campaña aparte).
  if (filters.seasons?.value) chips.push(`Temporadas: ${filters.seasons.value.split(':').join(', ')}`);
  if (filters.years?.value) chips.push(`Años: ${filters.years.value.split(':').join(', ')}`);

  if (depositRolesValue) {
    const labels = depositRolesValue.split(':').filter(Boolean).map(depositTypeLabel);
    chips.push(`Roles: ${labels.join(', ')}`);
  }
  if (depositGroupsValue) {
    const names = depositGroupsValue
      .split(':')
      .filter(Boolean)
      .map((id) => groupOptions.find((o) => String(o.value) === id)?.label ?? id);
    chips.push(`Grupos: ${names.join(', ')}`);
  }
  if (depositsValue === 'ALL') chips.push('Depósitos: todos (incl. central)');
  else if (depositsValue) {
    const names = depositsValue
      .split(':')
      .filter(Boolean)
      .map((id) => depositOptions.find((o) => String(o.value) === id)?.label ?? id);
    chips.push(`Depósitos: ${names.join(', ')}`);
  }

  if (familyQuery) chips.push(`Búsqueda: "${familyQuery}"`);

  if (chips.length === 0) return null;
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
      {chips.map((label, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <span key={i} style={chipStyle}>
          {label}
        </span>
      ))}
    </div>
  );
};
